import { render, staticRenderFns } from "./booking-create.vue?vue&type=template&id=f8270aa4&"
import script from "./booking-create.vue?vue&type=script&lang=js&"
export * from "./booking-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports